/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ExpandedWorkOrder, VersionedPagination } from "../../utils/Interfaces";

export interface WorkOrdersState {
    existingWorkOrders: ExpandedWorkOrder[];
    existingWorkOrdersCount: number;
    existingWorkOrdersLoaded: boolean;
    existingWorkOrdersVersion: string;
}

const initialState: WorkOrdersState = {
    existingWorkOrders: [],
    existingWorkOrdersCount: 0,
    existingWorkOrdersLoaded: false,
    existingWorkOrdersVersion: "",
};

export const workOrdersSlice = createSlice({
    name: "workorders",
    initialState,
    reducers: {
        setExistingWorkOrders: (state, action: PayloadAction<VersionedPagination<ExpandedWorkOrder>>) => {
            state.existingWorkOrders = action.payload.results;
            state.existingWorkOrdersCount = action.payload.count;
            state.existingWorkOrdersLoaded = true;
            state.existingWorkOrdersVersion = action.payload.version;
        },
    },
});

export const { setExistingWorkOrders } = workOrdersSlice.actions;

export const selectExistingWorkOrders = (state: RootState) => state.workOrders.existingWorkOrders;
export const selectExistingWorkOrdersCount = (state: RootState) => state.workOrders.existingWorkOrdersCount;
export const selectExistingWorkOrdersLoaded = (state: RootState) => state.workOrders.existingWorkOrdersLoaded;
export const selectExistingWorkOrdersVersion = (state: RootState) => state.workOrders.existingWorkOrdersVersion;

export default workOrdersSlice.reducer;
